import { Component } from 'react'
import companyImg from '../../../../../../assets/images/company.png'
import './styles.sass'
import { RouterProps, withRouter } from '../../../../../../insfrastructure/utils/with-router-component';

class CompanyFormConfirmationRequest extends Component<RouterProps> {
  constructor(props: any) {
    super(props);
  }

  render() {
    return (
      <div className='company-sign-up-form-confirmation-request'>
          <div className='content'>
            <div className='block'>
              <div>
                <h3>Parabéns!</h3>
                <p>Agora você faz parte da maior rede mecânicos do Brasil</p>
              </div>
              <img src={companyImg} />
              <div>
                <p>Enviamos um e-mail para {this.props.location.state?.email || 'seu e-mail'}.</p>
                <p>Por favor, confirme e prossiga com a ativação da sua conta.</p>
              </div>
            </div>
          </div>
      </div>
    )
  }
}

export default withRouter(CompanyFormConfirmationRequest);